import React from "react";
import { motion } from "framer-motion";

import aboutImg from "../../assets/images/safai.avif"; 
import heroBg from "../../assets/images/abouttop.jpeg"; 
import ctaBg from "../../assets/images/aboutbgbottom.jpg"; 

import Cook from "../../components/Whychoos.jsx";

export default function About() {
  const textVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <>

      <motion.section
        className="relative text-white text-center py-24 px-4 bg-no-repeat bg-center bg-cover"
        style={{
          backgroundImage: `url(${heroBg})`,
        }}
        initial="hidden"
        animate="visible"
        variants={textVariant}
      >
        <div className="absolute inset-0 bg-black/10"></div>

        <div className="relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">
            About Us
          </h1>

          <p className="max-w-3xl mx-auto text-lg md:text-xl">
            We are dedicated to providing the best cleaning services with a focus on quality,
            safety, and eco-friendly solutions.
          </p>
        </div>
      </motion.section>

      <section className="max-w-6xl mx-auto px-6 md:px-12 py-20 grid md:grid-cols-2 gap-12 items-center">
        <motion.div
          className="text-center md:text-left"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#e58505]">
            Our Mission
          </h2>

          <p className="text-gray-700 mb-4 leading-relaxed">
            Our mission is to make every home and office spotless while using safe and eco-friendly cleaning products.
            We aim to create a cleaner and healthier environment for everyone.
          </p>

          <p className="text-gray-700 leading-relaxed">
            With a team of trained professionals and modern equipment, we provide consistent and reliable cleaning services.
            Customer satisfaction is always our top priority.
          </p>
        </motion.div>

        <motion.div
          className="rounded-xl overflow-hidden shadow-lg"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <img
            src={aboutImg}
            alt="About Cleaning"
            className="w-full h-80 md:h-96 object-cover object-center"
          />
        </motion.div>
      </section>

      <Cook />

      <section
        className="relative text-white text-center py-24 px-4 bg-no-repeat bg-center bg-cover"
        style={{
          backgroundImage: `url(${ctaBg})`,
        }}
      >

        <div className="absolute inset-0 bg-black/10"></div>

        {/* Content */}
        <div className="relative z-10 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Want a Cleaner Space?
          </h2>

          <p className="mb-8 text-lg md:text-xl">
            Contact us today and get a personalized cleaning plan for your home or office.
          </p>
        </div>
      </section>
    </>
  );
}
